import CustomInputWithButton from 'framework/components/CustomInputWithButton';
import DPDropDown from 'framework/components/DPDropDown';
import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react'
import { Col, Row, Spinner } from 'reactstrap';
import SelectableListModal from './SelectableListModal';
import DPSearchBoxDynamic from 'framework/components/DPSearchBoxDynamic';
import moment from 'moment';
import { GetReportStructure, GetTransactionDropdown, GetUserLocations } from './myReportsController';
import { get } from 'lodash';
import CustomDropdown from 'framework/components/CustomDropdown';



const MyReportsContent = forwardRef(({ menuCode }, ref) => {

    const ApiURL = window.Links.ApiURL

    // Add loading state
    const [isLoading, setIsLoading] = useState(false);
    const [locationList, setLocationList] = useState([]);
    const [transactionList, setTransactionList] = useState([]);

    const modalRef1 = useRef();
    const modalRef2 = useRef();

    const [formData, setFormData] = useState({
        selectedReport: "",
        reportList: [],
        location1: [],
        isLocation1SwitchEnabled: false,
        location2: [],
        isLocation2SwitchEnabled: false,
        dateSelection1: moment().format("YYYY-MM-DD"),
        dateSelection2: moment().format("YYYY-MM-DD"),
        product: "",
        isProductSwitchEnabled: false,
        supplier: "",
        isSupplierSwitchEnabled: false,
        customer: "",
        isCustomerSwitchEnabled: false,
        user: "",
        isUserSwitchEnabled: false,
        staff: "",
        isStaffSwitchEnabled: false,
        documentNo: "",
        transactionType: "",
        isAllTransactionType: false,
        group: []
    })

    const [uiSetup, setUiSetup] = useState({
        location1: 0,
        location1Caption: "",
        location2: 0,
        location2Caption: "",
        dateFilter1: 0,
        dateFilter1Caption: "",
        dateFilter2: 0,
        dateFilter2Caption: "",
        groupFilter: 0,
        productFilter: 0,
        productFilterCaption: "",
        supplierFilter: 0,
        customerFilter: 0,
        customerGroupFilter: 0,
        customerGroupFilterCaption: "",
        paymodeFilter: 0,
        staffFilter: 0,
        userFilter: 0,
        transactionFilter: 0,
    })

    useEffect(async () => { 

        var obj = JSON.parse(localStorage.getItem("authUser"))
        var user = obj[2]
        const response = await GetUserLocations(user)
        if (response.success) {
            setLocationList(response.data);
        }

        const transactionResponse = await GetTransactionDropdown()
        if (transactionResponse.success) {
            setTransactionList(transactionResponse.data);
        }

    }, []);


    useImperativeHandle(ref, () => ({

        getSelectedItems: () => formData,
        getUiSetup: () => uiSetup,
        reset: () => resetForm(),
        setReportList: (data) => {
            setFormData((prev) => ({ ...prev, reportList: data }));
        }
    }));


    const resetForm = () => {
        setFormData({
            selectedReport: "",
            reportList: [],
            location1: [],
            isLocation1SwitchEnabled: false,
            location2: [],
            isLocation2SwitchEnabled: false,
            dateSelection1: moment().format("YYYY-MM-DD"),
            dateSelection2: moment().format("YYYY-MM-DD"),
            product: "",
            isProductSwitchEnabled: false,
            supplier: "",
            isSupplierSwitchEnabled: false,
            customer: "",
            isCustomerSwitchEnabled: false,
            user: "",
            isUserSwitchEnabled: false,
            staff: "",
            isStaffSwitchEnabled: false,
            documentNo: "",
            transactionType: "",
            isAllTransactionType: false,
            group: []
        });
    }



    const [searchData, setSearchData] = useState({
        productEnable: false,
        supplierEnable: false,
        customerEnable: false,
        userEnable: false,
    });


    const handleOpenLocation1 = () => {
        modalRef1.current.show();
    };

    const handleOpenLocation2 = () => {
        modalRef2.current.show();
    };


    const getLabelsFromValues = (values, fullData) => {
        return fullData
            .filter(item => values.includes(item.value))
            .map(item => item.label)
            .join(', ');
    };

    return (
        <React.Fragment>
            {/* Loading Overlay */}

            <Row>
                <Col md="6">
                    <DPDropDown
                        rowClass="mb-4-sm"
                        labelText="Reports"
                        optionGroup={formData.reportList}
                        selectedGroup={formData.selectedReport}
                        onChange={async (e) => {
                            setFormData({ ...formData, selectedReport: e["value"] });
                            setIsLoading(true);

                            // Record start time
                            const startTime = Date.now();

                            // Fetch data
                            const response = await GetReportStructure(e["value"]);
                            if (response.success) {
                                setUiSetup(response.data);


                                setFormData(prev => ({
                                    ...prev,
                                    location1: [],
                                    isLocation1SwitchEnabled: false,
                                    location2: [],
                                    isLocation2SwitchEnabled: false,
                                    dateSelection1: moment().format("YYYY-MM-DD"),
                                    dateSelection2: moment().format("YYYY-MM-DD"),
                                    product: "",
                                    isProductSwitchEnabled: false,
                                    supplier: "",
                                    isSupplierSwitchEnabled: false,
                                    customer: "",
                                    isCustomerSwitchEnabled: false,
                                    user: "",
                                    isUserSwitchEnabled: false,
                                    staff: "",
                                    isStaffSwitchEnabled: false,
                                    documentNo: "",
                                    transactionType: "",
                                    isAllTransactionType: false,
                                    group: []
                                }));

                            }

                            // Calculate elapsed time and ensure minimum 1 second display
                            const elapsedTime = Date.now() - startTime;
                            const remainingTime = Math.max(0, 1000 - elapsedTime);

                            // Wait for the remaining time if needed
                            setTimeout(() => {
                                setIsLoading(false);
                            }, remainingTime);
                        }}
                    />
                </Col>
                <Col md="6">
                    {formData.reportList.find((item) => item.value === formData.selectedReport)?.description ?? ""}
                </Col>
            </Row>

            {isLoading ? (
                <div className='mt-5' style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100%',
                    width: '100%'
                }}>
                    <Spinner style={{ width: '2rem', height: '2rem', color: '#556ee6' }} />
                    <div style={{ marginTop: '15px', fontSize: '16px', fontWeight: '500' }}>
                        Loading UI...
                    </div>
                </div>
            ) :
                <>
                    <Row>
                        <Col md="6" hidden={uiSetup.location1 === 0}>
                            <CustomInputWithButton
                                label={uiSetup.location1Caption || "Location1"}
                                id="location1"
                                name="location1"
                                value={getLabelsFromValues(formData.location1, locationList)}
                                onChange={(e) => setFormData({ ...formData, location1: e.target.value })}
                                //onButtonClick={formData.onLocation1ButtonClick}
                                onButtonClick={handleOpenLocation1}
                                handleSwitchToggle={(e) => {
                                    setFormData({
                                        ...formData,
                                        isLocation1SwitchEnabled: e,
                                        location1: []
                                    })

                                    if (e) {
                                        modalRef1.current.reset();
                                    }
                                }}
                                isSwitchEnabled={formData.isLocation1SwitchEnabled}
                                input1Disabled={true}
                                buttonDisabled={formData.isLocation1SwitchEnabled}

                            />

                            <SelectableListModal
                                ref={modalRef1}
                                data={locationList}
                                pageSize={10}
                                title={uiSetup.location1Caption || "Locations"}
                                onClose={(selectedItems) => {
                                    setFormData({ ...formData, location1: selectedItems });
                                }}
                            />

                        </Col>
                        <Col md="6" hidden={uiSetup.location2 === 0}>
                            <CustomInputWithButton
                                label={uiSetup.location2Caption || "Location2"}
                                id="location2"
                                name="location2"
                                value={getLabelsFromValues(formData.location2, locationList)}
                                onChange={(e) => setFormData({ ...formData, location2: e.target.value })}
                                onButtonClick={handleOpenLocation2}
                                handleSwitchToggle={(e) => {
                                    setFormData({
                                        ...formData,
                                        isLocation2SwitchEnabled: e,
                                        location2: []
                                    })

                                    if (e) {
                                        modalRef2.current.reset();
                                    }
                                }}
                                isSwitchEnabled={formData.isLocation2SwitchEnabled}
                                input1Disabled={true}
                                buttonDisabled={formData.isLocation2SwitchEnabled}
                            />

                            <SelectableListModal
                                ref={modalRef2}
                                data={locationList}
                                pageSize={10}
                                title={uiSetup.location2Caption || "Locations"}
                                onClose={(selectedItems) => {
                                    setFormData({ ...formData, location2: selectedItems });
                                }}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md="6" hidden={uiSetup.dateFilter1 === 0}>
                            <CustomInputWithButton
                                label={uiSetup.dateFilter1Caption || "Date1"}
                                id="date1"
                                name="date1"
                                type='date'
                                value={formData.dateSelection1}
                                onChange={(e) => setFormData({ ...formData, dateSelection1: e.target.value })}
                                hideSwitch={true}
                                hideButton={true}
                            />
                        </Col>
                        <Col md="6" hidden={uiSetup.dateFilter2 === 0}>
                            <CustomInputWithButton
                                label={uiSetup.dateFilter2Caption || "Date2"}
                                id="date2"
                                name="date2"
                                type='date'
                                value={formData.dateSelection2}
                                onChange={(e) => setFormData({ ...formData, dateSelection2: e.target.value })}
                                hideSwitch={true}
                                hideButton={true}
                            />
                        </Col>
                    </Row>
                    <Row>

                        <Col md="6" hidden={uiSetup.productFilter === 0}>
                            <CustomInputWithButton
                                label={uiSetup.productFilterCaption || "Product"}
                                id="product"
                                name="product"
                                value={formData.product}
                                onChange={(e) => {

                                    if (e.target.value.length > 50) {
                                        e.target.value = e.target.value.slice(0, 50);
                                    }

                                    setFormData({ ...formData, product: e.target.value })
                                }}
                                onButtonClick={() => setSearchData({ ...searchData, productEnable: !searchData.productEnable })}
                                handleSwitchToggle={(e) => {
                                    setFormData({
                                        ...formData,
                                        isProductSwitchEnabled: e,
                                        product: ""
                                    })
                                }}
                                isSwitchEnabled={formData.isProductSwitchEnabled}
                                input1Disabled={formData.isProductSwitchEnabled}
                                buttonDisabled={formData.isProductSwitchEnabled}
                            />
                        </Col>


                        <DPSearchBoxDynamic
                            searchData={[]}
                            columns={[]}
                            mainTitle={"Product Search"}
                            SelectType={"radio"}
                            isOpen={searchData.productEnable}
                            toggle={() => setSearchData({ ...searchData, productEnable: !searchData.productEnable })}
                            getSelect={(e, row) => {
                                setFormData({ ...formData, product: row.PLU_CODE });
                                setSearchData({ ...searchData, productEnable: false });
                            }}
                            APIURL={ApiURL}
                            URLPath={"PRODUCT"}
                            MenuCode={menuCode}
                            KeyVal={'PRD'}
                            searchBy={'PLU_CODE'}
                            FilterStr={'a'}
                        />

                    </Row>
                    <Row>

                        <Col md="6" hidden={uiSetup.supplierFilter === 0}>
                            <CustomInputWithButton
                                label={"Supplier"}
                                id="supplier"
                                name="supplier"
                                value={formData.supplier}
                                onChange={(e) => setFormData({ ...formData, supplier: e.target.value })}
                                onButtonClick={() => setSearchData({ ...searchData, supplierEnable: !searchData.supplierEnable })}
                                handleSwitchToggle={(e) => {
                                    setFormData({
                                        ...formData,
                                        isSupplierSwitchEnabled: e,
                                        supplier: ""
                                    })
                                }}
                                isSwitchEnabled={formData.isSupplierSwitchEnabled}
                                input1Disabled={formData.isSupplierSwitchEnabled}
                                buttonDisabled={formData.isSupplierSwitchEnabled}
                            />
                        </Col>

                        <DPSearchBoxDynamic
                            searchData={[]}
                            columns={[]}
                            mainTitle={"Supplier Search"}
                            SelectType={"radio"}
                            isOpen={searchData.supplierEnable}
                            toggle={() => setSearchData({ ...searchData, supplierEnable: !searchData.supplierEnable })}
                            getSelect={(e, row) => {
                                setFormData({ ...formData, supplier: row.SM_CODE });
                                setSearchData({ ...searchData, supplierEnable: false });
                            }}
                            APIURL={ApiURL}
                            URLPath={"SUPPLIER"}
                            MenuCode={menuCode}
                            KeyVal={'SUP'}
                            searchBy={'SM_CODE'}
                            FilterStr={'a'}
                        />
                    </Row>
                    <Row>

                        <Col md="6" hidden={uiSetup.customerFilter === 0}>
                            <CustomInputWithButton
                                label={"Customer"}
                                id="customer"
                                name="customer"
                                value={formData.customer}
                                onChange={(e) => setFormData({ ...formData, customer: e.target.value })}
                                onButtonClick={() => setSearchData({ ...searchData, customerEnable: !searchData.customerEnable })}
                                handleSwitchToggle={(e) => {
                                    setFormData({
                                        ...formData,
                                        isCustomerSwitchEnabled: e,
                                        customer: ""
                                    })
                                }}
                                isSwitchEnabled={formData.isCustomerSwitchEnabled}
                                input1Disabled={formData.isCustomerSwitchEnabled}
                                buttonDisabled={formData.isCustomerSwitchEnabled}
                            />
                        </Col>

                        <DPSearchBoxDynamic
                            searchData={[]}
                            columns={[]}
                            mainTitle={"Customer Search"}
                            SelectType={"radio"}
                            isOpen={searchData.customerEnable}
                            toggle={() => setSearchData({ ...searchData, customerEnable: !searchData.customerEnable })}
                            getSelect={(e, row) => {
                                setFormData({ ...formData, customer: row.CM_CODE });
                                setSearchData({ ...searchData, customerEnable: false });
                            }}
                            APIURL={ApiURL}
                            URLPath={"CUSTOMER"}
                            MenuCode={menuCode}
                            KeyVal={'CUS'}
                            searchBy={'CM_CODE'}
                            FilterStr={'a'}
                        />

                    </Row>

                    <Row>
                        <Col md="6" hidden={uiSetup.userFilter === 0}>

                            <CustomInputWithButton
                                label={"User"}
                                id="user"
                                name="user"
                                value={formData.user}
                                onChange={(e) => setFormData({ ...formData, user: e.target.value })}
                                onButtonClick={() => setSearchData({ ...searchData, userEnable: !searchData.userEnable })}
                                handleSwitchToggle={(e) => {
                                    setFormData({
                                        ...formData,
                                        isUserSwitchEnabled: e,
                                        user: ""
                                    })
                                }}
                                isSwitchEnabled={formData.isUserSwitchEnabled}
                                input1Disabled={formData.isUserSwitchEnabled}
                                buttonDisabled={formData.isUserSwitchEnabled}
                            />

                        </Col>

                        <DPSearchBoxDynamic
                            searchData={[]}
                            columns={[]}
                            mainTitle={"User Search"}
                            SelectType={"radio"}
                            isOpen={searchData.userEnable}
                            toggle={() => setSearchData({ ...searchData, userEnable: !searchData.userEnable })}
                            getSelect={(e, row) => {
                                setFormData({ ...formData, user: row.UH_ID });
                                setSearchData({ ...searchData, userEnable: false });
                            }}
                            APIURL={ApiURL}
                            URLPath={"USER"}
                            MenuCode={menuCode}
                            KeyVal={'USE'}
                            searchBy={'UH_ID'}
                            FilterStr={'a'}

                        />

                    </Row>
                    <Row>
                        <Col md="6" hidden={uiSetup.transactionFilter === 0 || uiSetup.transactionFilter === 2}>
                            <CustomDropdown
                                id={"transactionType"}
                                name={"transactionType"}
                                label={"Transaction Type"}
                                options={transactionList}
                                labelText={"Transaction Type"}
                                value={formData.transactionType}
                                onChange={(e) => setFormData({ ...formData, transactionType: e.target.value })}
                                handleSwitchToggle={(e) => {

                                    setFormData({
                                        ...formData,
                                        isAllTransactionType: e,
                                        transactionType: ""
                                    })
                                }}
                                isSwitchEnabled={formData.isAllTransactionType}
                                dropdownDisabled={formData.isAllTransactionType}
                                hideSwitch={true}
                                isLoading={false}
                                isDisabled={false}
                                className={"mb-2"}
                                isClearable={false}
                                isSearchable={true}
                            />
                        </Col>

                        <Col md="6" hidden={uiSetup.transactionFilter === 0 || uiSetup.transactionFilter === 2}>
                            <CustomInputWithButton
                                label={"Transaction DocumentNo"}
                                id="documentNo"
                                name="documentNo"
                                value={formData.documentNo}
                                onChange={(e) => setFormData({ ...formData, documentNo: e.target.value })}
                                hideButton={true}
                                hideSwitch={true}
                                isSwitchEnabled={true}
                                input1Disabled={false}
                                buttonDisabled={true}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md="6" hidden={uiSetup.transactionFilter === 0 || uiSetup.transactionFilter === 1}>
                            <CustomDropdown
                                id={"transactionType"}
                                name={"transactionType"}
                                label={"Transaction Type"}
                                options={transactionList}
                                labelText={"Transaction Type"}
                                value={formData.transactionType}
                                onChange={(e) => setFormData({ ...formData, transactionType: e.target.value })}
                                handleSwitchToggle={(e) => {

                                    setFormData({
                                        ...formData,
                                        isAllTransactionType: e,
                                        transactionType: ""
                                    })
                                }}
                                isSwitchEnabled={formData.isAllTransactionType}
                                dropdownDisabled={formData.isAllTransactionType}
                                isLoading={false}
                                isDisabled={false}
                                className={"mb-2"}
                                isClearable={false}
                                isSearchable={true}
                            />
                        </Col>

                    </Row>
                </>}
        </React.Fragment>
    )
});

export default MyReportsContent;